export const ORGANIZATION_TYPES = {
  AUTOMOTIVE: "automotive",
  STANDARD: "standard",
  // Compatibility alias for code written before the public type was standardized.
  GENERAL: "standard",
}

export const DEFAULT_ORGANIZATION_TYPE = ORGANIZATION_TYPES.AUTOMOTIVE

export const normalizeOrganizationType = (value) =>
  value === ORGANIZATION_TYPES.STANDARD || value === "general"
    ? ORGANIZATION_TYPES.STANDARD
    : DEFAULT_ORGANIZATION_TYPE

export const isAutomotiveOrganization = (organization) =>
  normalizeOrganizationType(organization?.organizationType ?? organization?.organization_type) ===
  ORGANIZATION_TYPES.AUTOMOTIVE

export const organizationTheme = (organization) => {
  const organizationType = normalizeOrganizationType(
    organization?.organizationType ?? organization?.organization_type,
  )
  const isAutomotive = organizationType === ORGANIZATION_TYPES.AUTOMOTIVE

  return {
    organizationType,
    isAutomotive,
    appName: isAutomotive ? "ASC TuneUp" : "TuneUp",
    auditProfileLabel: isAutomotive ? "ASC automotive" : "organization",
    customAuditRulesEnabled:
      organization?.customAuditRulesEnabled === true ||
      organization?.custom_audit_rules_enabled === true,
  }
}
